"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionIFA = exports.getDeviceId = exports.getUUID = exports.base64EncodeUint8Array = exports.base64DecodeUint8Array = exports.stringToUUID = exports.arrayToString = exports.stringToArray = exports.debounce = exports.clamp = void 0;
const clamp = (num, clamp, higher) => higher ? Math.min(Math.max(num, clamp), higher) : Math.min(num, clamp);
exports.clamp = clamp;
const debounce = (func, wait = 500) => {
    // Only way to type declare for both browsers and Node
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func(...args);
        }, wait);
    };
};
exports.debounce = debounce;
const stringToArray = (string) => {
    const buffer = new ArrayBuffer(string.length * 2); // 2 bytes for each char
    const array = new Uint16Array(buffer);
    for (let i = 0, strLen = string.length; i < strLen; i++) {
        array[i] = string.charCodeAt(i);
    }
    return array;
};
exports.stringToArray = stringToArray;
const arrayToString = (array) => {
    const uint16array = new Uint16Array(array);
    return String.fromCharCode.apply(null, uint16array);
};
exports.arrayToString = arrayToString;
const stringToUUID = (input) => {
    // if the input is 32 char and contain only hex characters, we assume it's a UUID
    if (/^[0-9a-fA-F]{32}$/.test(input)) {
        const p1 = input.slice(0, 8);
        const p2 = input.slice(8, 12);
        const p3 = input.slice(12, 16);
        const p4 = input.slice(16, 20);
        const p5 = input.slice(20);
        return [p1, p2, p3, p4, p5].join("-");
    }
    // Assuming we already have a UUID string
    return null;
};
exports.stringToUUID = stringToUUID;
const base64DecodeUint8Array = (input) => {
    const raw = window.atob(input);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));
    for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
};
exports.base64DecodeUint8Array = base64DecodeUint8Array;
const base64EncodeUint8Array = (input) => {
    const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    while (i < input.length) {
        chr1 = input[i++];
        chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index
        chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output +=
            keyStr.charAt(enc1) +
                keyStr.charAt(enc2) +
                keyStr.charAt(enc3) +
                keyStr.charAt(enc4);
    }
    return output;
};
exports.base64EncodeUint8Array = base64EncodeUint8Array;
const getUUID = () => {
    return [
        generateS4(),
        generateS4(),
        "-",
        generateS4(),
        "-",
        generateS4(),
        "-",
        generateS4(),
        "-",
        generateS4(),
        generateS4(),
        generateS4(),
    ].join("");
};
exports.getUUID = getUUID;
const DUID_STORAGE_KEY = "deviceId";
/**
 * Get device ID either from sessionToken or generated using getUUID(), the generated one will be stored in localStorage
 */
const getDeviceId = (sessionToken) => {
    if (sessionToken) {
        const parts = sessionToken.split("|");
        return parts[7];
    }
    const storedDeviceId = localStorage.getItem(DUID_STORAGE_KEY);
    if (storedDeviceId) {
        return storedDeviceId;
    }
    const deviceId = (0, exports.getUUID)();
    try {
        localStorage.setItem(DUID_STORAGE_KEY, deviceId);
    }
    catch (e) {
        // no-op
    }
    return deviceId;
};
exports.getDeviceId = getDeviceId;
/**
 * Get a Identifier for Advertising
 */
const getSessionIFA = () => {
    const ifa = (0, exports.getUUID)();
    return {
        ifa,
        ifaType: "sessionid",
    };
};
exports.getSessionIFA = getSessionIFA;
const generateS4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};
//# sourceMappingURL=helperMethods.js.map